import React from "react";
import styles from "./Button.module.css";

const Button = ({ website }) => {
  return (
    <div className={styles.btn}>
      <a href={website} target="_blank" rel="noopener noreferrer">
        VISIT WEBSITE
      </a>
    </div>
  );
};

export default Button;
